import React from 'react';
import { makeStyles } from '@material-ui/core';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import { toDateFormatWithoutT } from '../../Helpers/dateHelper';
import { severityTypes } from '../../Config/constants';
import FlagstoneTheme from '../../Config/flagstoneTheme';

export default function MessageContent(props) {
    const classes = useStyles();

    let icon = <React.Fragment></React.Fragment>
    switch (props.message.notificationSeverityId) {
        case severityTypes.WARNING:
            icon = <InfoIcon className={classes.infoIcon}></InfoIcon>;
            break;
        case severityTypes.ERROR:
            icon = <ErrorIcon className={classes.errorIcon}></ErrorIcon>;
            break;
        default:
    }

    const openURL = () => {
        window.open(JSON.parse(props.message.metaData).Url, "_blank")
    }   

    return (
        <div className={classes.messageContainer}>
            <div className={classes.dateTime}>
                {toDateFormatWithoutT(props.message.insertedOn)}
            </div>
            <div className={classes.message} style={{ borderLeft: "8px solid " + props.message.backgroundColorInHex, backgroundColor: props.backgroundColor }}>
                <div className={classes.icon} style={{ color: props.message.foregroundColorInHex, paddingTop: props.iconPadding }}>{icon}</div>
                <div className={classes.text} style={{ width: props.textWidth }}>
                    {props.message.message}
                    {JSON.parse(props.message.metaData).Url && JSON.parse(props.message.metaData).Url.length > 0 ?
                     <React.Fragment><br /><a onClick={() => openURL()} className={classes.moreInfo}>More info...</a></React.Fragment> 
                     : 
                     <React.Fragment></React.Fragment>}</div>
            </div>
        </div>
    )

}

const useStyles = makeStyles(() => ({
    icon: {
        marginRight: "20px",
        paddingTop: "0px !important",
        alignItems: "center"

    },
    message: {
        display: "flex",
        flexDirection: "row",
        borderRadius: "6px",
        paddingTop: "10px",
        boxSizing: "border-box",
        paddingLeft: "10px",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: '#020100',
        paddingBottom: "10px",
        minHeight: "65px",
        wordWrap: "break-word",
        overflowY: "auto",
        alignItems: "center"

    },
    dateTime: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: '#8D8D8D',
        marginTop: "10px"
    },
    moreInfo: {
        cursor: "pointer",
        color: FlagstoneTheme.palette.primary.main,
    }

}));